import "../styles/App.css";
import "../styles/pages/What.css";

import Header from "../components/Header";
import WhatCard from "../components/WhatCard";
import useIsMobile from "../hooks/useIsMobile";
import Carousel from "../components/ImageCarousel";

const loadWhatCards = () => {
  const whatCards = [
    {
      icon: "/cardIcon/cardIcon1.png",
      title: "Consultas",
      content: [
        "Consulta de Avaliação Psicológica;",
        "Acompanhamento Psicológico;",
        "Psicoterapia de apoio individual.",
      ],
      button: "Agende aqui.",
      buttonLink:
        "https://docs.google.com/forms/d/e/1FAIpQLScIWg1MnMAWXzlBLRJbyERplxmzNHc04LESW5qQgIff9rLEjw/viewform?usp=header",
    },
    {
      icon: "/cardIcon/cardIcon2.png",
      title: "Programa de parentalidade reflexiva",
      content: [
        "Programa psicopedagógico baseado na mentalização;",
        "Grupos de pais.",
      ],
      button: "Saiba mais aqui.",
      buttonLink: "https://www.parentalidadereflexiva.pt/",
    },
    {
      icon: "/cardIcon/cardIcon3.png",
      title: "Parcerias e eventos",
      content: ["Veja aqui as nossas parcerias e eventos."],
      button: "",
      buttonLink: "",
    },
  ];

  return whatCards.map((card) => {
    return (
      <WhatCard
        icon={card.icon}
        title={card.title}
        content={card.content}
        button={card.button}
        buttonLink={card.buttonLink}
      />
    );
  });
};

const desktopView = <div className="whatOrganizer"> {loadWhatCards()} </div>;
const mobileView = <div className="whatCarousel"> <Carousel items={loadWhatCards()} /> </div>;

function What() {
  const isMobile = useIsMobile(801);

  return (
    <div id="work" className="section">
      <div className="whatWrapper">
        <Header content="O Que Fazemos?" />
        {isMobile ? mobileView : desktopView}
      </div>
    </div>
  );
}

export default What;
